import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Input from '../../../components/ui/Input';

const ManualCodeEntry = ({ onSubmit, loading }) => {
  const [qrCode, setQrCode] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e?.preventDefault();
    setError('');

    if (!qrCode?.trim()) {
      setError('Please enter a QR code');
      return;
    }

    onSubmit?.(qrCode?.trim());
    setQrCode('');
  };

  return (
    <div className="bg-card rounded-lg p-6 border border-border">
      <h2 className="text-xl font-bold mb-6">Manual Code Entry</h2>
      <form onSubmit={handleSubmit} className="space-y-6">
        {/* QR Code Input */}
        <div>
          <label className="block text-sm font-medium mb-2">
            QR Code ID
          </label>
          <Input
            type="text"
            placeholder="Enter QR code manually..."
            value={qrCode}
            onChange={(e) => setQrCode(e?.target?.value)}
            disabled={loading}
            icon="QrCode"
          />
          <p className="text-xs text-muted-foreground mt-1">
            Use this option if the QR code cannot be scanned
          </p>
        </div>

        {/* Error Message */}
        {error && (
          <div className="p-3 bg-destructive/10 border border-destructive rounded-lg">
            <p className="text-sm text-destructive flex items-center gap-2">
              <Icon name="AlertCircle" size={16} />
              {error}
            </p>
          </div>
        )}

        {/* Submit Button */}
        <Button
          type="submit"
          disabled={!qrCode?.trim() || loading}
          loading={loading}
          iconName="Check"
          className="w-full"
        >
          Validate Code
        </Button>
      </form>
      {/* Instructions */}
      <div className="mt-6 p-4 bg-muted rounded-lg">
        <h3 className="font-semibold mb-2 flex items-center gap-2">
          <Icon name="Info" size={18} />
          When to Use Manual Entry
        </h3>
        <ul className="text-sm text-muted-foreground space-y-1 ml-6 list-disc">
          <li>QR code is damaged or unreadable</li>
          <li>Camera is not available or not working</li>
          <li>Member provides code verbally or in text</li>
          <li>Testing or troubleshooting purposes</li>
        </ul>
      </div>
      {/* Quick Actions */}
      <div className="mt-6 space-y-3">
        <h3 className="font-semibold text-sm">Quick Actions</h3>
        <div className="grid grid-cols-2 gap-3">
          <Button
            variant="outline"
            size="sm"
            iconName="Search"
            onClick={() => {
              // Could open member search modal
            }}
          >
            Search Member
          </Button>
          <Button
            variant="outline"
            size="sm"
            iconName="History"
            onClick={() => {
              // Could show recent codes
            }}
          >
            Recent Codes
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ManualCodeEntry;